export default "__VITE_ASSET__BHOpbX7n__"